import { Action, Types } from "./url.actions"

export type UrlState = {
  path: string
  params: any
}

const initialState: UrlState = {
  path: "",
  params: undefined,
}

export default (state = initialState, action: Action): UrlState => {
  switch (action.type) {
    case Types.SET_URL:
      return {
        ...state,
      }

    case Types.SET_URL_SUCCESS:
      return {
        ...state,
        params: {
          ...action.payload.params,
        },
      }

    case Types.RESET_URL:
      return {
        ...state,
        path: "",
        params: undefined,
      }

    default:
      return state
  }
}
